import React from 'react';
import styles from '../irlObservations2026.module.css';
import { ModalShell, WorkstreamOptions } from '../chrome';
import { searchIrlRequests } from '../../../apiServices/irlScreenApi';

export default function IRL_Create_Request({ draft, onChange, onCreate, onCancel, workstreams, members, folders }) {
    const [relatedHits, setRelatedHits] = React.useState([]);
    const skipSearchRef = React.useRef(false);
    const update = (key, value) => onChange({ ...draft, [key]: value });

    React.useEffect(() => {
        const query = (draft.relatedQuery || '').trim();
        if (!query) {
            setRelatedHits([]);
            return undefined;
        }
        if (skipSearchRef.current) {
            skipSearchRef.current = false;
            return undefined;
        }
        const handle = window.setTimeout(() => {
            searchIrlRequests(query)
                .then(data => setRelatedHits(data.results || []))
                .catch(() => setRelatedHits([]));
        }, 250);
        return () => window.clearTimeout(handle);
    }, [draft.relatedQuery]);

    const selectRelated = item => {
        skipSearchRef.current = true;
        setRelatedHits([]);
        onChange({ ...draft, related: item.id, relatedQuery: `${item.id} ${item.title}` });
    };

    return (
        <ModalShell width="form">
            <div className={styles.formHead}>
                <h2 className={styles.modalTitle}>New information request</h2>
            </div>
            <div className={styles.formBody}>
                <label className={styles.fieldLabel}>Request question *</label>
                <textarea className={styles.textarea} value={draft.question} onChange={event => update('question', event.target.value)} placeholder="What do you want to ask?" />
                <div className={styles.fieldBlock}>
                    <label className={styles.fieldLabel}>Description / context</label>
                    <textarea className={styles.textarea} value={draft.context} onChange={event => update('context', event.target.value)} placeholder="Optional additional context..." />
                </div>
                <div className={styles.fieldRow}>
                    <div>
                        <label className={styles.fieldLabel}>Owning workstream *</label>
                        <select className={styles.selectField} value={draft.workstream} onChange={event => update('workstream', event.target.value)}>
                            <option value="">Select a workstream</option>
                            <WorkstreamOptions workstreams={workstreams} valueKey="id" />
                        </select>
                    </div>
                    <div>
                        <label className={styles.fieldLabel}>Priority</label>
                        <select className={styles.selectField} value={draft.priority} onChange={event => update('priority', event.target.value)}>
                            <option>High</option>
                            <option>Medium</option>
                            <option>Low</option>
                        </select>
                    </div>
                </div>
                <div className={styles.fieldRow}>
                    <div>
                        <label className={styles.fieldLabel}>Owner</label>
                        <select className={styles.selectField} value={draft.owner} onChange={event => update('owner', event.target.value)}>
                            <option value="">Me</option>
                            {(members || []).map(member => (
                                <option key={member.id} value={member.id}>
                                    {member.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className={styles.fieldLabel}>Due date</label>
                        <input className={styles.field} type="date" value={draft.due} onChange={event => update('due', event.target.value)} />
                    </div>
                </div>
                <div className={styles.fieldBlock}>
                    <label className={styles.fieldLabel}>Suggested VDR destination folder</label>
                    <select className={styles.selectField} value={draft.folder} onChange={event => update('folder', event.target.value)}>
                        <option value="">Unassigned</option>
                        {(folders || []).map(folder => (
                            <option key={folder.id} value={folder.id}>
                                {folder.path || folder.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={styles.fieldBlock}>
                    <label className={styles.fieldLabel}>Related IRL</label>
                    <div className={styles.typeahead}>
                        <input
                            className={styles.field}
                            value={draft.relatedQuery || draft.related || ''}
                            onChange={event => onChange({ ...draft, relatedQuery: event.target.value, related: event.target.value })}
                            placeholder="Search by IRL id or title..."
                            autoComplete="off"
                        />
                        {relatedHits.length > 0 && (
                            <div className={styles.typeaheadMenu} role="listbox">
                                {relatedHits.map(item => (
                                    <button key={item.id} type="button" onClick={() => selectRelated(item)}>
                                        {item.id} — {item.title}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className={styles.formFoot}>
                <button type="button" className={styles.primaryBtn} onClick={onCreate} disabled={!draft.question.trim() || !draft.workstream}>
                    Create request
                </button>
                <button type="button" className={styles.mutedBtn} onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </ModalShell>
    );
}
